// extracted by mini-css-extract-plugin
module.exports = {"root":"b1ddd01198--root--q_cCX","arrow":"b1ddd01198--arrow--LFWcI","arrow-collapsed":"b1ddd01198--arrow-collapsed--EMRma"};